import { useCmowEmpList } from 'api/common/cmow-fetch'
import { SearchBar, Line, InputRadio, Text, ListTitle } from 'components'
import { useState } from 'react'
import { useEffect } from 'react'
import { queryClient } from 'index'
import useModal from 'hook/useModal'
import { isEmptyString } from 'utils/common-util'
import { getMessage } from 'utils/message-util'

export default function CmowEmp({ info = {}, ok = () => {} }) {
  const { alertModal, openCmow, closeModal } = useModal()

  let param = {
    empNoNm: '',
  }
  const [total, setTotal] = useState(0)
  const { data, refetch } = useCmowEmpList(param, false)
  const goSearch = (value) => {
    if (isEmptyString(value)) {
      alertModal(getMessage('common_validation_004', { target: '이름 또는 사번' }))
      return
    }
    param.empNoNm = value
    refetch()
  }

  useEffect(() => {
    return () => {
      queryClient.removeQueries('cmowEmpList')
      setTotal(0)
    }
  }, [])

  useEffect(() => {
    if (data) {
      setTotal(data.data.length)
    }
  }, [data])

  const goCmow = (emp) => {
    openCmow(info, emp, () => {
      closeModal()
    })
  }

  return (
    <>
      <main>
        {/* todo: 팝업 헤더 */}
        <div className="wrapper">
          <Text text="공유할 이름 또는 사번을 검색하세요." className="mb16 f-16 f-bold c-3 " />
          <SearchBar goSearch={(value) => goSearch(value)} />
        </div>

        <ListTitle title="검색결과" count={total} className="wrapper mt16" />

        <Line size="1" color="gray" />

        <ul className="wrapper basic-list">
          {data?.data?.map((item, index) => (
            <li className="flex flex-1" key={`emp_${index}`}>
              <InputRadio
                title={
                  <>
                    <div className="flex-col flex-1 gap-4">
                      {/* <Text className="f-14 mono-6" text={item.userId} /> */}
                      <Text className="f-14 mono-3" text={`${item.empNm} (${item.shpNm})`} />
                    </div>
                  </>
                }
                name="r1"
                className="flex1"
                onClick={() => goCmow(item)}
              />
            </li>
          ))}
        </ul>
      </main>
    </>
  )
}
